import { render, staticRenderFns } from "./EditarContaDialog.vue?vue&type=template&id=26ffe247&"
import script from "./EditarContaDialog.vue?vue&type=script&lang=js&"
export * from "./EditarContaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditarContaDialog.vue"
export default component.exports